import getMuiTheme from 'material-ui/styles/getMuiTheme';

export const white = 'white';
export const whiteHover = '#E9F7FC';
export const background20 = '#FBFBFB';
export const darkGray = '#414142';
export const mediumGray = '#636364';
export const lightGray = '#8D8D8E';
export const lightestGray = '#E1E1E1';
export const petrol = '#00395A';
export const petrolLight = '#67849D';
export const petrol03 = '#F3F5F7';
export const violet = '#2D0749';
export const violetLight = '#C195E9';
export const linkBlue = '#42B7E8';
export const warning = '#FBB055';

export const brandGreen = '#1BCDAC';
export const brandGreen40 = 'rgba(28, 204, 174, 0.4)';
export const brandBlue = '#24BBEE';
export const brandBlue40 = 'rgba(36, 187, 238, 0.4)';
export const brandBlue10 = '#E6F4F9';
export const brandBlueText = '#14b6ed';
export const brandBlueTextHover = '#109fcf';

export const bodyColor = '#616163';
export const backgroundColor = '#f0f0f0';

export const fbColor = '#89a1d1';
export const twitterColor = '#79c5f5';
export const linkedinColor = '#56b7ef';
export const youtubeColor = '#fd3f4b';
export const telegramColor = '#67bee5';

export const imageGradient = 'linear-gradient(45deg, rgba(0, 57, 90, 0.4),rgba(45, 7, 73, 0.4))';
export const faceImageGradient = 'linear-gradient(45deg, rgba(0, 57, 90, 0.6),rgba(45, 7, 73, 0.15))';
export const darkImageGradient = 'linear-gradient(rgba(2, 43, 62, 0.88),rgba(2, 43, 62, 0.88))';
export const blueGradient = 'linear-gradient(rgba(0, 57, 90, 0.7),rgba(0, 57, 90, 0.7))';
export const backgroundGradient = 'linear-gradient(to bottom, #FEFEFE, #FAFAFA)';
export const primaryGradientPurple = 'linear-gradient(to right, #00395A, #2D0749)';
export const primaryGradient = `linear-gradient(45deg, ${brandBlue}, ${brandGreen})`;
export const primaryGradStart1 = '#3CB4E2';
export const primaryGradStop1 = '#34BBD6';
export const primaryGradStart2 = '#33BAD5';
export const primaryGradStop2 = '#2CC0C8';
export const primaryGradStart3 = '#2CC0C8';
export const primaryGradStop3 = '#25C7BC';
export const primaryGradStart4 = '#24C7BA';
export const primaryGradStop4 = '#1BCEAD';
export const loadingColor = '#F3F3F8';

export const boxShadowSmall = '4px 5px 20px 0px rgba(0,0,0,0.1)';
export const boxShadow = '8px 10px 20px 0px rgba(0,0,0,0.1)';
export const boxShadowHover = '10px 12px 28px 0px rgba(0,0,0,0.1)';

export const mainFont = 'Open Sans, sans-serif';

export const detailWidth = '50%';
export const detailWidthDesktopSm = '65%';
export const detailWidthTablet = '90%';

export const defaultWidth = '75%';
export const defaultWidthDesktopSm = '80%';
export const defaultWidthTablet = '90%';

export const detailMargin = `calc((100% - ${detailWidth}) / 2)`;
export const detailMarginDesktopSm = `calc((100% - ${detailWidthDesktopSm}) / 2)`;
export const detailMarginTablet = `calc((100% - ${detailWidthTablet}) / 2)`;

export const defaultMargin = `calc((100% - ${defaultWidth}) / 2)`;
export const defaultMarginDesktopSm = `calc((100% - ${defaultWidthDesktopSm}) / 2)`;
export const defaultMarginTablet = `calc((100% - ${defaultWidthTablet}) / 2)`;

export const minNavHeight = '4rem';
export const maxNavHeight = '7rem';
export const headerHeight = 'calc(12rem + (14 - 12) * (100vw - 31.32rem)/(68.75 - 31.32))';
export const landingHeaderHeight = 'calc(14rem + (16 - 14) * (100vw - 31.32rem)/(68.75 - 31.32))';
export const cardTitleFontSize = '1.1rem';
export const cardContentFontSize = '0.9rem';

export const amcorTheme = getMuiTheme({
  fontFamily: 'AmcorPro, sans-serif',
  palette: {
    primary1Color: petrol,
    primary2Color: petrolLight,
    primary3Color: violet,
    accent1Color: linkBlue,
    accent2Color: brandBlue,
  },
  tabs: {
    backgroundColor: 'transparent',
    textColor: bodyColor,
    selectedTextColor: brandBlue,
  },
  appBar: {
    color: petrol,
  },
  datePicker: {
    selectColor: linkBlue,
  },
});



// WEBPACK FOOTER //
// ./src/styles/styleVariables.js